import initActions from '../lib/init-actions'
import initRules from '../lib/init-rules'
import runDelayedRules from '../lib/run-delayed-rules'

window.addiesaas.cart_rules.runDelayedRules = runDelayedRules

window.addiesaas.cart_rules.commonArgs = {}
window.addiesaas.cart_rules.commonArgs.querystring = Object.fromEntries((new URL(window.location.href)).searchParams.entries())

export function beforeReady() {
    const eventBus = window.addiesaas.$core.EventBus
    const store = window.addiesaas.store

    initActions(eventBus)

    const rules = window.addiesaas.cart_rules.rules || []

    initRules(rules, eventBus)

    eventBus.$on('cart.item.added', async item => {
        await processCartItem(item)
    })

    eventBus.$on('cart.item.updated', async (item, silent) => {
        if (silent !== true) {
            item = store.getters['Shop/Orders/Cart/cartItems'][item.id]

            await removeRelatedCartItems(item)

            await processCartItem(item)
        }
    })

    eventBus.$on('cart.item.removed', async (item) => {
        await removeRelatedCartItems(item)
    })

    async function removeRelatedCartItems(item) {
        if (item.cartRuleAddedCartItemIds) {
            for (const itemId of item.cartRuleAddedCartItemIds) {
                try {
                    await store.dispatch('Shop/Orders/Cart/removeCartItem', { id: itemId })
                } catch (e) {
                    console.error(e)
                }
            }
        }
    }

    async function processCartItem(item) {
        await eventBus.$$emitAsync('cart_rules.cart.item.added', {
            item,
            product_id: item.payload?.product_id,
        })
    }

    function selectProduct({ product, location_id }) {
        if (product) {
            eventBus.$emit('cart_rules.product.selected', {
                product_id: product.id,
                product,
                location_id,
            })
        }
    }

    eventBus.$on('buy-card.change.product-with-location', selectProduct)
    eventBus.$on('card.reload.select-product-with-location', selectProduct)

    eventBus.$on('card.check-balance.success', card => {
        eventBus.$emit('cart_rules.card.check-balance.success', {
            card,
            balance: card,
        })
    })

    window.addiesaas.store.dispatch('Marketing/CartRules/Log/logSession')
}

export function ready() {
    const eventBus = window.addiesaas.$core.EventBus
    runDelayedRules(eventBus)
}
